import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import { ToastrService } from "ngx-toastr";
import {environment} from "../../../../environments/environment";
import {Event} from "../../../models/event";
import {EventType} from "../../../models/event-type";
import { PreviewTranslationsControllerService } from "../../../services/preview-translations-controller/preview-translations-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-preview-full",
  templateUrl: "./preview-full.component.html",
  styleUrls: ["./preview-full.component.scss"],
  providers: [PreviewTranslationsControllerService],
})
export class PreviewFullComponent extends BaseError implements OnInit {

  @ViewChild("childModal") public childModal;
  public style: object = {};
  @ViewChild("previewIframe")
  public previewIframe: ElementRef;
  public messageEvent: any;
  public previewUrl: any = "";
  public isPreviewLoading = true;
  public fieldKey = "";
  public action = "";
  public scrollHeight = 2500;
  public previewTranslation: any;
  public serviceId: string;
  public authToken: string;
  public tokenJWT: string;
  public translations: any[];
  public receiveMessage: any = (event: any) => this.handlePreviewMessage(event);
  public iframeWindow: any;

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute, public toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.serviceId && params.serviceId !== "new") {
        this.serviceId = params.serviceId;
        this.authToken = localStorage.getItem("authToken");
        this.tokenJWT = localStorage.getItem("tokenJWT");
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.E_REGISTRATIONS_HOME_URL);
        this.showPreview();
      } else {
        this.serviceId = null;
      }
    });
  }

  public showPreview() {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage.bind(this), false);
      const timer = setInterval(() => {
        if (this.iframeWindow) {
          // wait until iframe loaded
          setTimeout(() => {
            this.sendPostMessage();
          }, 5000);
          clearInterval(timer);
        }
      }, 500);
    } else {
      (window as any).attachEvent("onmessage", this.receiveMessage.bind(this));
    }
    this.isPreviewLoading = false;
  }

  public sendPostMessage(): void {
    if (!this.iframeWindow) {
      this.iframeWindow = this.previewIframe.nativeElement.contentWindow;
    }
    if (this.iframeWindow) {
      this.iframeWindow.postMessage({action: "get_all_translations"}, "*");
    }
  }

  public showEdit() {
    if (this.action && this.action !== "resize") {
      this.childModal.show();
    }
  }

  public handlePreviewMessage(messageStr: any) {
    let message: any;
    if (messageStr.data && typeof messageStr.data === "string") {
      message = {};
      message.data = JSON.parse(messageStr.data);
    } else {
      message = messageStr;
    }
    if (message.data && message.data.action) {
      this.action = message.data.action;
      this.messageEvent = message;

      if (this.action === "resize") {
        this.scrollHeight = message.data.scrollHeight;
      }

      if (this.action === "translation_edit") {
        this.previewTranslation = {
          key: message.data.key,
          value: message.data.translation,
          language: message.data.lang,
        };
      }

      if (this.action === "get_token") {
        this.replyMessage({action: "get_token_resp", token_jwt: this.tokenJWT});
      }

      if (this.action === "get_all_translations_resp") {
        this.translations = message.data.translations;
      }

      this.serviceId = message.data.service_id;
      this.fieldKey = message.data.data_id;

      // Actually there could be more blocked values and I think we should only allow some predefined actions as array.
      if (this.action !== "get_token" && this.action !== "get_all_translations_resp") {
        this.showEdit();
      }
    }
  }

  public onResizeEnd(event: ResizeEvent): void {
    this.style = {
      position: "fixed",
      width: `${event.rectangle.width}px`,
    };
  }

  public closeModal(event: Event) {
    if (event.eventType === EventType.Add || event.eventType === EventType.Delete || event.eventType === EventType.Update) {
      this.replyMessage({action: "bpa_requests_reload"});
    }
    this.childModal.hide();
  }

  public replyMessage(message) {
    this.messageEvent.source.postMessage(message, "*");
  }

}
